import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ListGroupItem } from 'react-bootstrap';

const styles = {
  rowContent: {
    display: 'flex',
    alignItems: 'center',
  },
  toggle: {
    marginRight: '12px',
  },
};

const FeatureFlagRow = props => {
  const { flag, onClick } = props;
  const variants = classNames({
    success: flag.isEnabled,
  });

  return (
    <ListGroupItem key={flag.id} onClick={onClick} bsStyle={variants}>
      <div style={styles.rowContent}>
        <input
          type="checkbox"
          checked={flag.isEnabled}
          style={styles.toggle}
          readOnly
        />
        {flag.id}
      </div>
    </ListGroupItem>
  );
};

FeatureFlagRow.proptypes = {
  flag: PropTypes.shape({
    id: PropTypes.string.isRequired,
    isEnabled: PropTypes.bool.isRequired,
  }).isRequired,
  onClick: PropTypes.func,
};

FeatureFlagRow.defaultProps = {
  onClick: () => {},
};

export default FeatureFlagRow;
